module.exports = __webpack_public_path__ + "static/media/mscore-icon-final.43962161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mscore-icon-final.png
// module id = 1337
// module chunks = 0